import { css } from '@/styled-system/css';

export const subGroupCard = css({
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
  borderRadius: 'md',
  padding: 'default',
});

export const subGroupsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  marginTop: 'default',
});

export const subGroupTitle = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
  margin: 0,
  marginBottom: 'tighter',
});

export const subGroupIcon = css({
  flexShrink: 0,
  color: 'brand.primary',
});

export const amenityList = css({
  listStyleType: 'disc',
  paddingLeft: 'default',
  margin: 0,
});

export const amenityItem = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  lineHeight: 'body-sm',
});

export const headerRight = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
});

export const spokeContainer = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  width: '100%',
});

export const footerButtonGroup = css({
  display: 'flex',
  gap: 'tighter',
  flexWrap: 'wrap',
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- caps spoke footer CTAs to the designed mobile button group width
  maxWidth: '400px',
  '& > *': {
    flex: 1,
  },
});

export const spokeContentContainer = css({
  paddingBlock: 'default',
});

export const leaseTermsText = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  margin: 0,
  lineHeight: 'body-sm',
});

export const policyList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  listStyleType: 'none',
  padding: 0,
  margin: 0,
});

export const policyRowInner = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const policyValue = css({
  fontWeight: 'bold',
  color: 'text.neutral',
});
